module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Plus-a33928e504f80229e17c8e06158032a7.svg";